import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { PAGETYPE } from 'src/app/core/enums/enums';
import { IRequestAdditionalFlightInfo } from 'src/app/core/models/request-info-flight.model';
import { ItineraryService } from 'src/app/search-result/services/itinerary.service';
import { SettingsService } from 'src/app/settings/services/settings.service';
import {
  AvailableClassOfService,
  Flight,
  IAdditionalFlightInfo,
  ISRequestValidationQuote,
  PnrInfo
} from 'src/app/core/models/itinerary.model';

@Component({
  selector: 'app-flight-content',
  templateUrl: './flight-content.component.html',
  styleUrls: ['./flight-content.component.scss']
})
export class FlightContentComponent implements OnDestroy {
  @Input() flight: Flight;
  @Input() isAirline: boolean;
  @Input() passengerCount = 1;
  @Input() index = 0;
  @Input() isInvoluntary: boolean;
  @Input() showBaggage = false;
  @Input() associatedFlight: number;
  @Input() isHeader: boolean;

  @Output() changeClass = new EventEmitter<string>();

  subscriptions = new Subscription();
  sRequestValidationError: Observable<boolean>;

  pnrInfo: PnrInfo;
  newAvailableClasses: AvailableClassOfService[];
  specialRequestsCodesQuote: string[] = [];
  specialRequestsCodesValid: string[] = [];

  infoFligth: IAdditionalFlightInfo;
  additionalFlightInfo = false;
  additionalFlightInfoRequested = false;
  moreInfoFligth = false;
  showSeatMap = false;
  showAltImage = false;
  isAm = false;
  openAditionalInformationModal = false;
  openSRequestValidationModal = false;
  flightHasSRequest = false;
  sRequestValidationReady = false;
  isValidProccessToSRVerification = false;
  indexArray = 0;

  originalValueClass = '';
  cabinValue = '';
  excludesClasses = ['Z', 'O', 'P', 'S', 'G', 'X'];
  economyClass = ['Y', 'W', 'B', 'M', 'U', 'K', 'H', 'L', 'Q', 'T', 'E', 'N', 'R', 'V'];
  businessClass = ['J', 'F', 'C', 'D', 'I'];

  constructor(
    private itService: ItineraryService,
    private settingsService: SettingsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.callComponentSubcriptions();
    this.itService.dispatchResetSRequestValidationPerFlight();
    this.originalValueClass = this.flight.classOfService;
    this.ValidateIsAirline();
    this.validateSRequestModal();
    this.validateCurrentProccessToSRVerification();
  }

  callComponentSubcriptions(): void {
    this.subscriptions.add(
      this.settingsService.getClientSettings().subscribe((settings: any) => {
        this.additionalFlightInfo = settings.additionalFlightInfo;
      })
    );

    this.subscriptions.add(
      this.itService
        .getPnrInfo()
        .pipe(take(1))
        .subscribe((pnr) => {
          if (pnr) {
            this.pnrInfo = pnr;
          }
        })
    );

    this.subscriptions.add(
      this.itService.getAdditionalFlightInfo().subscribe((info) => {
        if (info && this.additionalFlightInfoRequested) {
          this.infoFligth = info;
          this.moreInfoFligth = true;
          this.openAditionalInformationModal = true;
        }
      })
    );
  }

  additionalInformationModalState(isOpen: boolean) {
    this.additionalFlightInfoRequested = false;
    this.openAditionalInformationModal = isOpen;
  }

  validateSRequestModal() {
    this.specialRequestsCodesQuote = [];

    this.pnrInfo.passengers.forEach((passenger) => {
      passenger.specialRequests.forEach((SR) => {
        if (SR?.coupons?.length <= 0) {
          this.flightHasSRequest = true;
          this.specialRequestsCodesQuote.push(SR.code);
        }
      });
    });

    this.sRequestValidationError = this.itService.getSRequestValidationError();

    this.subscriptions.add(
      this.itService.getSRequestValidationResponse().subscribe((res) => {
        this.specialRequestsCodesValid = [];
        if (res) {
          res.forEach((sRequest) => {
            if (sRequest?.canBeApplied) {
              this.specialRequestsCodesValid.push(sRequest.code);
            }
          });
          this.sRequestValidationReady = true;
        }
      })
    );
  }

  validateCurrentProccessToSRVerification() {
    window.location.href.includes(PAGETYPE.involuntaryChange) ||
    window.location.href.includes(PAGETYPE.newFlow) ||
    window.location.href.includes(PAGETYPE.voluntaryChange)
      ? (this.isValidProccessToSRVerification = true)
      : (this.isValidProccessToSRVerification = false);
  }

  verifyIfIsCompatible(code: string) {
    return this.specialRequestsCodesValid.includes(code);
  }

  flightInfoPopUp(): void {
    const requestInfoFlight: IRequestAdditionalFlightInfo = {
      pnr: this.pnrInfo.code,
      gds: this.pnrInfo.gds,
      flightNumber: this.flight.number,
      marketingCarrierCode: this.flight.marketingCarrier.code,
      arrivalLocationCode: this.flight.arrivalLocation.code,
      departureLocationCode: this.flight.departureLocation.code,
      departureDate: this.flight.departureDate
    };

    this.itService.dispatchGetAdditionalFlightInfo(requestInfoFlight);
    this.additionalFlightInfoRequested = true;
  }

  launchAncillariesVerificationModal() {
    if (this.flightHasSRequest) {
      const ancillariesValidationQuote: ISRequestValidationQuote = {
        gds: this.pnrInfo.gds,
        codes: this.specialRequestsCodesQuote,
        bookingCode: this.pnrInfo.code,
        transactionId: this.pnrInfo.transactionId,
        flight: {
          carrier: this.flight.operatingCarrier.code,
          flightNumber: this.flight.number,
          flightEquipment: this.flight.flightEquipment,
          departureDate: this.flight.departureDate,
          departureCity: this.flight.departureLocation.code,
          arrivalCity: this.flight.arrivalLocation.code,
          classOfService: this.flight.classOfService,
          status: this.flight.status,
          message: ''
        }
      };
      this.specialRequestsCodesValid = [];
      this.sRequestValidationReady = false;
      this.itService.dispatchSRequestValidationPerFlight(ancillariesValidationQuote);
      this.openSRequestValidationModal = true;
    }
  }

  ValidateIsAirline() {
    this.settingsService.getClientIsAirline().subscribe((resultParameterAirline) => {
      this.isAirline = resultParameterAirline;
    });
    this.newAvailableClasses = [];
    if (this.isAirline) {
      this.BuildExcludeClasess();
    } else {
      this.newAvailableClasses = this.flight.availableClasses;
    }
  }

  BuildExcludeClasess() {
    this.isAm = this.flight?.operatingCarrier?.code === 'AM';
    let economyName = 'economy';
    let businessName = 'business';
    let typeSegment = this.associatedFlight != undefined ? this.associatedFlight - 1 : 0;
    this.originalValueClass =
      this.flight.classOfService != undefined
        ? this.flight.classOfService
        : this.pnrInfo.passengers[0].ticket.segments?.length > 0 &&
          this.pnrInfo.passengers[0].ticket.segments[typeSegment]?.flights[0].classOfService;
    this.originalValueClass = this.originalValueClass.toUpperCase();
    let classOfServiceFilter =
      this.pnrInfo.itinerary.segments?.length > 0
        ? this.pnrInfo.itinerary.segments[typeSegment]?.flights.filter(
            (x) => x.classOfService === this.originalValueClass
          )
        : this.pnrInfo.passengers[0].ticket.segments[typeSegment]?.flights.filter(
            (x) => x.classOfService === this.originalValueClass
          );
    if (this.pnrInfo.itinerary.segments?.length > 0 && classOfServiceFilter?.length > 0) {
      this.cabinValue = classOfServiceFilter[0].cabin;
    } else {
      this.cabinValue = this.economyClass.find((x) => x === this.originalValueClass)
        ? economyName
        : businessName;
    }
    this.indexArray = this.flight.availableClasses.findIndex(
      (x) => x.classOfService === this.originalValueClass
    );

    if (this.indexArray === -1) {
      this.indexArray = this.flight.availableClasses?.length - 1;
    }

    this.flight.availableClasses.forEach((obj) => {
      if (!this.excludesClasses.includes(obj.classOfService)) {
        switch (this.cabinValue) {
          case economyName:
            this.ValidateClassForCabin(obj, this.economyClass, this.indexArray);
            break;
          case businessName:
            this.ValidateClassForCabin(obj, this.businessClass, this.indexArray);
            break;
        }
      }
    });

    if (this.isInvoluntary && !this.isHeader) {
      this.isAirline
        ? (this.flight.classOfService = 'undefined')
        : (this.flight.availabilityClass = true);
    }
  }

  ValidateClassForCabin(obj: AvailableClassOfService, array: string[], indexArray) {
    let positionInArray = this.flight.availableClasses.findIndex(
      (x) => x.classOfService === obj.classOfService
    );

    if (!this.validateIsManualFlow()) {
      if (!array.includes(obj.classOfService) || indexArray < positionInArray) {
        obj.disabled = true;
      }
    }
    this.newAvailableClasses.push(obj);
  }

  ChangeValue(event) {
    if (event != undefined) {
      this.flight.classOfService = event;
    } else {
      this.flight.classOfService = undefined;
    }
  }

  validateIsItineraryUrl() {
    return this.router.url.includes(PAGETYPE.itinerary);
  }

  validateClassUpgrade(e: any) {
    return e === 'F' && this.pnrInfo?.applyClassUpgrade;
  }

  validateIsManualFlow() {
    return this.router.url.includes(PAGETYPE.newFlow);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
